import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { Injectable } from '@angular/core';
import { ManagementTagResponse } from 'api-clipping';
import { Subject } from 'rxjs/internal/Subject';

interface UpdateTagDropzone {
	location: 'TAGZONE-FORM' | 'TAGZONE-LIST' | 'TAGZONE-FILTER';
	itemId: string;
	tags: ManagementTagResponse[];
}

@Injectable({
	providedIn: 'root',
})
export class TagsDropAssignService {
	draggedTag: ManagementTagResponse | undefined;
	selectedTags: ManagementTagResponse[] = [];
  	manuallyselectedTags: ManagementTagResponse[] = [];

	updateTagDropzone: Subject<UpdateTagDropzone> = new Subject();

	private readonly TAG_DROPZONES_IDS: Map<string, 'TAGZONE-FORM' | 'TAGZONE-LIST' | 'TAGZONE-FILTER'> = new Map([
		['tag-dropzone-form', 'TAGZONE-FORM'],
		['tag-dropzone-list', 'TAGZONE-LIST'],
		['tag-dropzone-filter', 'TAGZONE-FILTER'],
	]);

	constructor() {}

	onDragStarted(tag: ManagementTagResponse, selectedTags: ManagementTagResponse[]) {
		this.draggedTag = tag;
		this.selectedTags = selectedTags;
	}

	drop(event: CdkDragDrop<any>) {
		let containerId = event.container.id;
		let itemId = '';
		if (containerId.includes('widget')) {
			// don't make any activity inside tags widget if droped there
			return;
		} else if (containerId.includes('tag-dropzone-list')) {
			itemId = containerId.replaceAll('tag-dropzone-list-', '');
			containerId = 'tag-dropzone-list';
		}

		const tagDropzone = this.TAG_DROPZONES_IDS.get(containerId);
		if (tagDropzone) {
			this.updateTagDropzone.next({
				location: tagDropzone,
				itemId,
				tags: this.selectedTags && this.selectedTags.length ? this.selectedTags : ([this.draggedTag] as ManagementTagResponse[]),
			});
		}

		if (event.previousContainer === event.container) {
			// moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
		} else {
			// copyArrayItem(event.previousContainer.data, event.container.data, event.previousIndex, event.currentIndex);
		}

		this.draggedTag = undefined;
		this.selectedTags = [];
	}
}
